"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const MapSideBarNavigationItem_vue_1 = __importDefault(require("@becrop/components/Tracking/Proposals/Playground/Components/MapSideBarNavigationItem.vue"));
let MapSideBarNavigation = class MapSideBarNavigation extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.activePanel = '';
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get panels() {
        return [
            {
                hook: 'sampling-points',
                label: 'Sampling Points',
                icon: 'TubeIcon',
            },
            {
                hook: 'export',
                label: 'Export map',
                icon: 'Settings2Icon',
            }
        ];
    }
    changePanel(panel) {
        this.$emit('changePanel', panel);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], MapSideBarNavigation.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'horizontal' })
], MapSideBarNavigation.prototype, "orientation", void 0);
MapSideBarNavigation = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            MapSideBarNavigationItem: MapSideBarNavigationItem_vue_1.default,
            ArrowLeft: lucide_vue_next_1.ArrowLeft,
            TubeIcon: bmk_ui_framework_1.TubeIcon,
            Settings2Icon: bmk_ui_framework_1.Settings2Icon,
            SettingsIcon: bmk_ui_framework_1.SettingsIcon
        },
    })
], MapSideBarNavigation);
exports.default = MapSideBarNavigation;
